import { Component, OnInit } from "@angular/core";

import {
    ApexChart,
    ApexNonAxisChartSeries,
    ApexResponsive,
    ApexAxisChartSeries,
    ApexXAxis,
} from "ng-apexcharts";

export type DonutChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    responsive: ApexResponsive[];
    labels: any;
};

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
};

@Component({
    selector: "app-buyer-analytics",
    templateUrl: "./buyer-analytics.component.html",
    styleUrls: ["./buyer-analytics.component.scss"],
})
export class BuyerAnalyticsComponent implements OnInit {
    public accountActivationOptions: Partial<DonutChartOptions> | any;
    public emailActivationOptions: Partial<DonutChartOptions> | any;
    public portalAdoptionOptions: Partial<ChartOptions> | any;
    vendorsList = [
        {
            vendor_code: "ALWPG5809L",
            vendor_name: "Indus Inc",
            vendor_email: "hello@indus.com",
            vdm_received_date: "12-08-22",
            onborading_started: "FALSE",
            account_status: "Pending Activation",
            email_delivery_status: "Email Bounced",
        },
        {
            vendor_code: "ALWPL580T5",
            vendor_name: "Balco",
            vendor_email: "team@balco.com",
            vdm_received_date: "12-08-22",
            onborading_started: "TRUE",
            account_status: "Account Activated",
            email_delivery_status: "Email Sent to Vendor",
        },
        {
            vendor_code: "ALWGGP809L",
            vendor_name: "Adani Hazira Port",
            vendor_email: "info@adani.com",
            vdm_received_date: "12-08-22",
            onborading_started: "TRUE",
            account_status: "Account Activated",
            email_delivery_status: "Email Sent to Vendor",
        },
        {
            vendor_code: "ALWPG580VM",
            vendor_name: "Rohan Builders Ltd",
            vendor_email: "team@Rohan.com",
            vdm_received_date: "12-08-22",
            onborading_started: "TRUE",
            account_status: "Account Activated",
            email_delivery_status: "Email Sent to Vendor",
        },
        {
            vendor_code: "ALWPG580ZE",
            vendor_name: "Nehan Co",
            vendor_email: "contact@nehan.com",
            vdm_received_date: "12-08-22",
            onborading_started: "TRUE",
            account_status: "Account Activated",
            email_delivery_status: "Email Sent to Vendor",
        },
    ];
    vendors: any;

    searchTerm: string = "";
    isError: any;
    isEmpty = false;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    filterKey: any;
    selectedOption = false;
    filterBy: any;
    loading = false;
    hideTable = true;
    isSelected = false;

    constructor() {
        this.accountActivationOptions = {
            series: [40, 20],
            chart: {
                height: 295,
                type: "donut",
            },
            colors: ["#18479f", "#5F87BF"],
            labels: ["Inactive Vendor Accounts", "Active Vendor Accounts"],
            legend: {
                show: true,
                position: "bottom",
            },
            dataLabels: {
                enabled: true,
                formatter: function (val: any, opts: any) {
                    return opts.w.config.series[opts.seriesIndex];
                },
            },
        };

        this.emailActivationOptions = {
            series: [50, 10],
            chart: {
                height: 295,
                type: "donut",
            },
            colors: ["#5caed6", "#9acce4"],
            labels: ["Emails Successfully Sent", "Emails Bounced"],
            legend: {
                show: true,
                position: "bottom",
            },
            dataLabels: {
                enabled: true,
                formatter: function (val: any, opts: any) {
                    return opts.w.config.series[opts.seriesIndex];
                },
            },
        };

        this.portalAdoptionOptions = {
            series: [
                {
                    data: [100, 70, 60, 50, 40],
                },
            ],
            chart: {
                height: 295,
                type: "bar",
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                },
            },
            legend: {
                show: true,
                position: "bottom",
            },
            colors: ["#555555", "#22778a", "#FE8F20", "#76B539", "#DED821"],
            xaxis: {
                type: "category",
                categories: [
                    "Total No. Of Vendors",
                    "Emails Sent",
                    "Started Onboarding",
                    "Onboarding Completed",
                    "Submitted an Invoice",
                ],
                labels: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                show: false,
                tooltip: {
                    enabled: false,
                },
            },
        };
    }

    checkAll(ev: any) {
        this.vendors.forEach((x: any) => (x.checked = ev.target.checked));
        this.onSelectChanges();
        //this.isSelected = true;
    }

    isAllCheck() {
        //this.isSelected = true;
        this.onSelectChanges();
        return this.vendors.every((p: any) => p.checked);
    }

    onSelectChanges() {
        this.isSelected = this.vendors.some((p: any) => p.checked);
    }

    refreshPos() {
        this.collectionSize = this.vendorsList.length;
        this.vendors = this.vendorsList
            .map((vendor, i) => ({ id: i + 1, ...vendor }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
    }

    reloadVendorTable() {
        this.searchTerm = "";
        this.page = 1;
        this.refreshPos();
    }

    deactiveAccount(account = null) {
        if (account !== null) {
            console.log(account + " this is the null value");
        } else {
            const selectedLine: any = [];
            this.vendors.forEach((p: any) => {
                if (p.checked === true) {
                    selectedLine.push(p);
                }
            });
            const selectedItems = selectedLine.map((r: any) => ({
                ...r,
            }));

            console.log(selectedItems);
            //console.log('true that');
        }
    }

    onFilter(option: any) {
        this.filterBy = option.target.value;
        console.log(this.filterBy + " option selected");
        this.selectedOption = true;
    }

    onSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            if (this.filterBy === "poNo") {
                this.vendors = this.vendorsList.filter((data) =>
                    data.vendor_name
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else {
                this.vendors = this.vendorsList.filter((data) =>
                    data.vendor_code
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            }
        } else {
            this.vendors = this.vendorsList;
        }
    }

    generalSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            this.vendors = this.vendorsList.filter(
                (data) =>
                    data.vendor_name
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.vendor_code
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
            );
        } else {
            this.vendors = this.vendorsList;
        }
    }

    ngOnInit(): void {
        this.refreshPos();
    }
}
